import defaultChart from './PDFBaseChart';
// Ranked bnr no longer used in print, replaced with RegionCompare
export default (metric, template) => defaultChart(metric, template);
